var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C8.29467 0 8.56379 0.167281 8.69422 0.431516L10.747 4.59028L15.3378 5.26129C15.6293 5.3039 15.8714 5.50829 15.9622 5.78855C16.0531 6.06881 15.977 6.37637 15.766 6.58194L12.4448 9.81677L13.2286 14.3868C13.2784 14.6772 13.159 14.9708 12.9206 15.144C12.6821 15.3172 12.366 15.34 12.1052 15.2029L8 13.044L3.89481 15.2029C3.63398 15.34 3.31788 15.3172 3.07945 15.144C2.84101 14.9708 2.7216 14.6772 2.77141 14.3868L3.55522 9.81677L0.234035 6.58194C0.0229766 6.37637 -0.0531053 6.06881 0.0377674 5.78855C0.12864 5.50829 0.370714 5.3039 0.662244 5.26129L5.25297 4.59028L7.30578 0.431516C7.43621 0.167281 7.70533 0 8 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStarFull);
export default __webpack_public_path__ + "static/media/icn-star-full.20021a454049dd1bc938a78cfafdc1cf.svg";
export { ForwardRef as ReactComponent };